import React, { useEffect } from 'react';
import { Provider } from 'react-redux';
import { ConnectedRouter } from 'connected-react-router';
import ContextFetchRoot from './contextFetch/Root';
import { Consumer as StoreConsumer } from './contexts/Store';
export default function AppProvider(_ref) {
  var children = _ref.children;
  useEffect(function () {
    var jssStyles = document.querySelector('#jss-server-side');

    if (jssStyles) {
      jssStyles.parentElement.removeChild(jssStyles);
    }
  }, []);
  return /*#__PURE__*/React.createElement(StoreConsumer, null, function (store) {
    return /*#__PURE__*/React.createElement(ContextFetchRoot, {
      suspense: true
    }, /*#__PURE__*/React.createElement(Provider, {
      store: store
    }, /*#__PURE__*/React.createElement(ConnectedRouter, {
      history: store.history
    }, children)));
  });
}